import { createApp } from 'vue'
import Percentage from './Percentage.vue'
import './assets/global.css'

createApp(Percentage).mount('#percentage')
